import axios from './ConfiguredAxios';
import App from 'PublicJs/App';

const CountriesApi  = {

	lookupSlug: (name, params = {}) => {
		return axios.get('/admin/countries/lookupSlug', {
			params: {
				q: name
			}
		});
	},

	lookup: (name) => {
		return axios.get('/admin/countries/lookup', {
			params: {
				q: name
			}
		});
	},

	getCountriesForProjects: () => {
		return axios.get(App.getLocale() + '/countries/allForProjects');
	},

	getCountriesForProfiles: () => {
		return axios.get(App.getLocale() + '/countries/allForProfiles');
	},

	getCountriesForJobs: () => {
		return axios.get(App.getLocale() + '/countries/allForJobs');
	},

	getAll: () => {
		return axios.get(App.getLocale() + '/countries/allForList');
	},
};

export default CountriesApi;
